import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from "react-i18next";
import Skeleton from 'react-loading-skeleton';
// import Swal from 'sweetalert2';

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import Button from "../../components/Button/Button";
import { showMemberGroup } from "../../store/ducks/memberGroup/actions";
import { filterErrorHandler, numFormat } from '../../hoc/Shared/utility';

class MemberGroupShow extends Component {
    state = {
        group_name: '',
        privilege: '',
        min_turnover: 0,
        max_turnover: 0,
        min_deposit: 0,
        max_deposit: 0,
        next_level_amount: 0,
        maintain_level_amount: 0,
        maintain_period: 0,
        min_withdrawal: 0,
        max_withdrawal: 0,
        monthly_bonus: 0,
        birthday_bonus: 0,
        birthday_bonus_turnover_multiply: 0,
        up_level_bonus: 0,
        reward_point: 0,
        level: 0,
        created_by: '',
        deposit_amount_per_point: 0,
        max_daily_withdrawal: 0,
        status: '',
        loading: true,
        designed_account_manager: 0,
        daily_withdrawal_limitation: 0,
        special_birthday_gift: 0,
        sport_rebate: 0,
        live_casino_rebate: 0,
        slot_rebate: 0,
        deposit_tier_maintain: 0,
        turnover_tier_maintain: 0,
        min_deposit_tier_upgrade: 0,
        min_turnover_tier_upgrade: 0,
        weekly_bonus: 0,
        coin_min_bet: 0,
        coin_reward: 0,
        turnover_weekly_target: 0,
        turnover_weekly_multiplier: 0,
        currency: '',
    };

    componentDidMount() {
        const showMemberGroupData = {};
        showMemberGroupData.member_group_id = this.props.show_member_group_id;
        showMemberGroupData.member_group_setting_id = this.props.show_member_group_setting_id
        this.props.showMemberGroup(showMemberGroupData);
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.show_member_group_data !== this.props.show_member_group_data) {
            if (nextProps.show_member_group_data.data.responseCode === 200 && nextProps.show_member_group_data.data.msgType === 'success') {
                let memberGroupData = nextProps.show_member_group_data.data.data;
                let memberGroupSettingData = nextProps.show_member_group_data.data.data.setting;

                this.setState({
                    loading: false,
                    group_name: memberGroupData.memberGroupName,
                    privilege: memberGroupData.memberGroupPrivilege,
                    min_turnover: memberGroupSettingData !== null ? memberGroupSettingData.minTurnover : '',
                    max_turnover: memberGroupSettingData !== null ? memberGroupSettingData.maxTurnover : '',
                    min_deposit: memberGroupSettingData !== null ? memberGroupSettingData.minDeposit : '',
                    max_deposit: memberGroupSettingData !== null ? memberGroupSettingData.maxDeposit : '',
                    next_level_amount: memberGroupSettingData !== null ? memberGroupSettingData.nextLevelAmount : '',
                    maintain_level_amount: memberGroupSettingData !== null ? memberGroupSettingData.maintainLevelAmount : '',
                    maintain_period: memberGroupSettingData !== null ? memberGroupSettingData.period : '',
                    min_withdrawal: memberGroupSettingData !== null ? memberGroupSettingData.minWithdrawal : '',
                    max_withdrawal: memberGroupSettingData !== null ? memberGroupSettingData.maxWithdrawal : '',
                    monthly_bonus: memberGroupSettingData !== null ? memberGroupSettingData.monthlyBonus : '',
                    birthday_bonus: memberGroupSettingData !== null ? memberGroupSettingData.birthdayBonus : '',
                    birthday_bonus_turnover_multiply: memberGroupSettingData !== null ? memberGroupSettingData.birthdayBonusTurnoverMultiply : '',
                    up_level_bonus: memberGroupSettingData !== null ? memberGroupSettingData.upLevelBonus : '',
                    reward_point: memberGroupSettingData !== null ? memberGroupSettingData.rewardPoint : '',
                    level: memberGroupData.memberGroupLevel,
                    deposit_amount_per_point: memberGroupSettingData !== null ? memberGroupSettingData.depositAmountPerPoint : '',
                    max_daily_withdrawal: memberGroupSettingData !== null ? memberGroupSettingData.maxDailyWithdrawal : '',
                    created_by: memberGroupSettingData !== null ? memberGroupSettingData.createdBy : '',
                    status: memberGroupSettingData !== null ? memberGroupSettingData.status : '',
                    designed_account_manager: memberGroupSettingData !== null ? memberGroupSettingData.designedAccountManager : '',
                    daily_withdrawal_limitation: memberGroupSettingData !== null ? memberGroupSettingData.dailyWithdrawalLimitation : '',
                    special_birthday_gift: memberGroupSettingData !== null ? memberGroupSettingData.specialBirthdayGift : '',
                    sport_rebate: memberGroupSettingData !== null ? memberGroupSettingData.sportRebate : '',
                    live_casino_rebate: memberGroupSettingData !== null ? memberGroupSettingData.liveCasinoRebate : '',
                    slot_rebate: memberGroupSettingData !== null ? memberGroupSettingData.slotRebate : '',
                    deposit_tier_maintain: memberGroupSettingData !== null ? memberGroupSettingData.depositTierMaintain : '',
                    turnover_tier_maintain: memberGroupSettingData !== null ? memberGroupSettingData.turnoverTierMaintain : '',
                    min_deposit_tier_upgrade: memberGroupSettingData !== null ? memberGroupSettingData.minDepositTierUpgrade : '',
                    min_turnover_tier_upgrade: memberGroupSettingData !== null ? memberGroupSettingData.minTurnoverTierUpgrade : '',
                    weekly_bonus: memberGroupSettingData !== null ? memberGroupSettingData.weeklyBonus : '',
                    coin_min_bet: memberGroupSettingData !== null ? memberGroupSettingData.coinMinBet : 0,
                    coin_reward: memberGroupSettingData !== null ? memberGroupSettingData.coinReward : 0,
                    turnover_weekly_target: memberGroupSettingData !== null ? memberGroupSettingData.turnoverWeeklyTarget : '',
                    turnover_weekly_multiplier: memberGroupSettingData !== null ? memberGroupSettingData.turnoverWeeklyMultiplier : '',
                    currency: memberGroupSettingData !== null ? memberGroupSettingData.currency : '',
                })
            } else {
                this.setState({
                    loading: false
                }, () => {
                    filterErrorHandler(nextProps.show_member_group_data.data.message);
                })
            }
        }

        return true;
    }

    render() {
        const { t } = this.props;
        const num_format = numFormat(this.state.currency);
        return (
            <Auxiliary>
                <div className="breadcrumb-header">
                    <div className="d-flex">
                        <div>
                            <div className="btn-group">
                                <div>
                                    <Button
                                        typeButton="button"
                                        classValue="btn btn-back-outline"
                                        idValue="back"
                                        buttonName={<i className="angle fe fe-chevron-left"></i>}
                                        clicked={() => this.props.changePageHandler("listing")}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto ml-2">{t("member-group.member-group")}</h4>
                        </div>
                    </div>
                </div>

                <div className="row row-sm">
                    <div className="col-12">
                        <div className="card  box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("member-group.show-member-group")}</h4>
                            </div>

                            <div className="card-body pt-0">
                                {this.state.loading === true
                                    ? <Skeleton count={4} />
                                    : <table className="table table-bordered table-striped">
                                        <tbody>
                                            <tr>
                                                <th>{t("member-group.names")}</th>
                                                <td field-key='name'>{t(`global.level.${this.props.currentUser.merchant_slug}.${this.state.level}`, this.state.group_name)}</td>
                                            </tr>

                                            <tr>
                                                <th>{t('member-group.lv')}</th>
                                                <td field-key='lv'>{this.state.level}</td>
                                            </tr>

                                            <tr>
                                                <th>{t('member-group.privilege')}</th>
                                                <td field-key='privilege'>{this.state.privilege}</td>
                                            </tr>

                                            {/* <tr>
                                            <th>{t('member-group.min-turnover')}</th>
                                            <td field-key='min_turnover'>{new Intl.NumberFormat("en-US", num_format).format(this.state.min_turnover)}</td>
                                        </tr>

                                        <tr>
                                            <th>{t('member-group.max-turnover')}</th>
                                            <td field-key='max_turnover'>{new Intl.NumberFormat("en-US", num_format).format(this.state.max_turnover)}</td>
                                        </tr> */}

                                            <tr>
                                                <th>{t('member-group.min-deposit')}</th>
                                                <td field-key='min_deposit'>{new Intl.NumberFormat("en-US", num_format).format(this.state.min_deposit)}</td>
                                            </tr>

                                            <tr>
                                                <th>{t('member-group.max-deposit')}</th>
                                                <td field-key='max_deposit'>{new Intl.NumberFormat("en-US", num_format).format(this.state.max_deposit)}</td>
                                            </tr>

                                            {/* <tr>
                                            <th>{t('member-group.next-level-amount')}</th>
                                            <td field-key='next_level_amount'>{new Intl.NumberFormat("en-US", num_format).format(this.state.next_level_amount)}</td>
                                        </tr>

                                        <tr>
                                            <th>{t('member-group.maint-level-amount')}</th>
                                            <td field-key='maint_level_amount'>{new Intl.NumberFormat("en-US", num_format).format(this.state.maintain_level_amount)}</td>
                                        </tr> */}

                                            <tr>
                                                <th>{t('member-group.min-withdrawal')}</th>
                                                <td field-key='min-withdrawal'>{new Intl.NumberFormat("en-US", num_format).format(this.state.min_withdrawal)}</td>
                                            </tr>


                                            <tr>
                                                {/* <th>{t('member-group.max-daily-withdrawal')}</th> */}
                                                <th>{t('member-group.daily-withdrawal-limitation')}</th>
                                                <td field-key='max-daily-withdrawal'>{new Intl.NumberFormat("en-US", num_format).format(this.state.max_daily_withdrawal)}</td>
                                            </tr>

                                            {/* <tr>
                                            <th>{t('member-group.daily-withdrawal-limitation')}</th>
                                            <td field-key='daily-withdrawal-limitation'>{new Intl.NumberFormat("en-US", num_format).format(this.state.daily_withdrawal_limitation)}</td>
                                        </tr> */}

                                            {/* <tr>
                                            <th>{t('member-group.max-withdrawal')}</th>
                                            <td field-key='max-withdrawal'>{new Intl.NumberFormat("en-US", num_format).format(this.state.max_withdrawal)}</td>
                                        </tr> */}

                                            {/* <tr>
                                            <th>{t('member-group.monthly-bonus')}</th>
                                            <td field-key='monthly-bonus'>{new Intl.NumberFormat("en-US", num_format).format(this.state.monthly_bonus)}</td>
                                        </tr>

                                        */}

                                            <tr>
                                                <th>{t('member-group.birthday-bonus')}</th>
                                                <td field-key='birthday-bonus'>{new Intl.NumberFormat("en-US", num_format).format(this.state.birthday_bonus)}</td>
                                            </tr>

                                            <tr>
                                                <th>{t('member-group.birthday-bonus-turnover-multiply')}</th>
                                                <td field-key='birthday-bonus'>{this.state.birthday_bonus_turnover_multiply}</td>
                                            </tr>

                                            <tr>
                                                <th>{t('member-group.up-level-bonus')}</th>
                                                <td field-key='up-level-bonus'>{new Intl.NumberFormat("en-US", num_format).format(this.state.up_level_bonus)}</td>
                                            </tr>


                                            {/* <tr>
                                            <th>{t('member-group.reward-point')}</th>
                                            <td field-key='reward-point'>{this.state.reward_point}</td>
                                        </tr>

                                        <tr>
                                            <th>{t('member-group.deposit-amount-point')}</th>
                                            <td field-key='deposit-amount-point'>{this.state.deposit_amount_per_point}</td>
                                        </tr> */}

                                            {/* <tr>
                                            <th>{t('member-group.designed-account-manager')}</th>
                                            <td field-key='designed-account-manager'>{this.state.designed_account_manager === 1 ? 'YES' : 'NO'}</td>
                                        </tr> */}

                                            {/* <tr>
                                            <th>{t('member-group.special-birthday-gift')}</th>
                                            <td field-key='special-birthday-gift'>{this.state.special_birthday_gift === 1 ? 'YES' : 'NO'}</td>
                                        </tr> */}

                                            <tr>
                                                <th>{t('member-group.sport-rebate')}</th>
                                                <td field-key='sport-rebate'>{this.state.sport_rebate}</td>
                                            </tr>

                                            <tr>
                                                <th>{t('member-group.live-casino-rebate')}</th>
                                                <td field-key='live-casino-rebate'>{this.state.live_casino_rebate}</td>
                                            </tr>

                                            <tr>
                                                <th>{t('member-group.slot-rebate')}</th>
                                                <td field-key='slot-rebate'>{this.state.slot_rebate}</td>
                                            </tr>


                                            <tr>
                                                <th>{t('member-group.maint-period')}</th>
                                                <td field-key='maint-period'>{this.state.maintain_period}</td>
                                            </tr>


                                            <tr>
                                                <th>{t('member-group.deposit-tier-maintain')}</th>
                                                <td field-key="deposit-tier-maintain">{new Intl.NumberFormat("en-US", num_format).format(this.state.deposit_tier_maintain)}</td>
                                            </tr>


                                            <tr>
                                                <th>{t('member-group.turnover-tier-maintain')}</th>
                                                <td field-key="turnover-tier-maintain">{new Intl.NumberFormat("en-US", num_format).format(this.state.turnover_tier_maintain)}</td>
                                            </tr>

                                            <tr>
                                                <th>{t('member-group.min-deposit')}</th>
                                                <td field-key="min-deposit">{new Intl.NumberFormat("en-US", num_format).format(this.state.min_deposit_tier_upgrade)}</td>
                                            </tr>

                                            <tr>
                                                <th>{t('member-group.min-turnover')}</th>
                                                <td field-key="min-turnover">{new Intl.NumberFormat("en-US", num_format).format(this.state.min_turnover_tier_upgrade)}</td>
                                            </tr>

                                            <tr>
                                                <th>{t("member-group.weekly-bonus")}</th>
                                                <td field-key="weekly-bonus">{new Intl.NumberFormat("en-US", num_format).format(this.state.weekly_bonus)}</td>
                                            </tr>

                                            <tr>
                                                <th>{t("member-group.coin-min-bet")}</th>
                                                <td>{new Intl.NumberFormat("en-US", num_format).format(this.state.coin_min_bet)}</td>
                                            </tr>

                                            <tr>
                                                <th>{t("member-group.coin-reward")}</th>
                                                <td>{this.state.coin_reward}</td>
                                            </tr>

                                            <tr>
                                                <th>{t("member-group.turnover-weekly-target-title")}</th>
                                                <td field-key="turnover-weekly-target">{new Intl.NumberFormat("en-US", num_format).format(this.state.turnover_weekly_target)}</td>
                                            </tr>

                                            {/* <tr>
                                            <th>{t("member-group.turnover-weekly-multiplier-title")}</th>
                                            <td field-key="turnover-weekly-multiplier">{new Intl.NumberFormat("en-US", num_format).format(this.state.turnover_weekly_multiplier)}</td>
                                        </tr> */}

                                            <tr>
                                                <th>{t('member-group.created-by')}</th>
                                                <td field-key='created-by'>{this.state.created_by}</td>
                                            </tr>

                                            {/* <tr>
                                                <th>{t('global.status')}</th>
                                                <td field-key='status'>{this.state.status === 1 ? 'Active' : 'Inactive'}</td>
                                            </tr> */}
                                        </tbody>
                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>


            </Auxiliary>
        )
    }
}

const mapStateToProps = state => {
    const { memberGroup } = state;

    //Getting the state from the reducers
    return {
        show_member_group_data: memberGroup.show_member_group_data,
        currentUser: state.currentUser.data,
    }
};

const mapDispatchToProps = {
    showMemberGroup
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(MemberGroupShow));